import { TOTAL_ESTIMATED_MINUTES } from "../data/journeyStages";
import { useJourneyStore, type AppMode } from "../game/state/journeyMachine";
import { QualitySelector } from "../components/QualitySelector";
import { ReducedMotionToggle } from "../accessibility/ReducedMotion";
import { FontScaleControl } from "../accessibility/FontScale";

const MODES: readonly { value: AppMode; title: string; description: string }[] = [
  {
    value: "recorrido",
    title: "Recorrido del aspirante",
    description: "Las 13 etapas del proceso en un CALE, paso a paso según el Anexo 60.",
  },
  {
    value: "sede-envigado",
    title: "Sede de referencia Envigado",
    description: "Exploración libre de la sede de referencia.",
  },
  {
    value: "red-nacional",
    title: "Red nacional CALE",
    description: "Vista general de la red de centros en Colombia.",
  },
];

export function HomeScreen() {
  const startJourney = useJourneyStore((s) => s.startJourney);

  return (
    <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col gap-8 px-4 py-10">
      <header className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold tracking-tight">CALE · Gemelo Digital Educativo</h1>
        <p className="text-lg text-[var(--cale-ink-muted)]">Institución Universitaria de Envigado</p>
      </header>

      <figure className="overflow-hidden rounded-[var(--radius-md)] border border-[var(--cale-border)]">
        <img
          src="/assets/hero-portada.png"
          alt="Render de referencia de la sede de un CALE: edificio institucional de dos plantas con banda verde azulado, entrada acristalada y cerros al fondo"
          className="aspect-video w-full object-cover"
          loading="eager"
        />
        <figcaption className="bg-[var(--cale-surface-raised)] px-3 py-1.5 text-xs text-[var(--cale-ink-muted)]">
          Anteproyecto de referencia [DISEÑO] — imagen sintética, no corresponde a una sede existente.
        </figcaption>
      </figure>

      <section aria-label="Modos de simulación" className="grid gap-3 sm:grid-cols-3">
        {MODES.map((m) => (
          <button
            key={m.value}
            type="button"
            onClick={() => startJourney(m.value)}
            className="flex flex-col gap-2 rounded-[var(--radius-md)] border border-[var(--cale-border)] bg-[var(--cale-surface-raised)] p-4 text-left shadow-[var(--shadow-panel)] transition hover:border-[var(--cale-accent)]"
          >
            <span className="font-semibold text-[var(--cale-accent)]">{m.title}</span>
            <span className="text-sm text-[var(--cale-ink-muted)]">{m.description}</span>
          </button>
        ))}
      </section>

      <section aria-label="Configuración" className="flex flex-col gap-4 rounded-[var(--radius-md)] border border-[var(--cale-border)] bg-[var(--cale-surface-raised)] p-4">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-[var(--cale-ink-muted)]">Configuración</h2>
        <QualitySelector />
        <ReducedMotionToggle />
        <FontScaleControl />
      </section>

      <p className="text-sm text-[var(--cale-ink-muted)]">
        Tiempo estimado del recorrido completo: {TOTAL_ESTIMATED_MINUTES} minutos.
      </p>
      <p className="rounded-[var(--radius-md)] border border-[var(--cale-warning-border)] bg-[var(--cale-warning-bg)] p-3 text-sm">
        Nota: esta aplicación es una simulación educativa. No tiene conexión con RUNT/SICOV y no es válida para
        trámites, evaluaciones ni certificaciones. El esquema CALE se presenta como anticipación educativa: su
        entrada en operación está aplazada y en revisión técnica por el Ministerio de Transporte (Circular
        Externa 20261010000317 del 28-08-2026).
      </p>
    </main>
  );
}
